import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=b54985c2&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"
import style0 from "./Activities.vue?vue&type=style&index=0&id=b54985c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54985c2",
  null
  
)

export default component.exports